import { api } from '../api-client.config';
import { TeamType } from 'src/types/domain.types';
import { useMutation } from '@tanstack/react-query';

const updateTeam = (team: TeamType) => api.put(`/teams/${team.team_id}`, team);

export const useUpdateTeamMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}) => {
  return useMutation({
    mutationKey: ['updateTeam'],
    mutationFn: updateTeam,
    onSuccess,
    onError,
  });
};
